import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

const FAQAccordion = ({
  faqData,
  defaultExpanded = null,
  keyPrefix = "faq",
}) => {
  return (
    <>
      {faqData.map((item, index) => (
        <Accordion
          key={`${keyPrefix}-${index}`}
          disableGutters
          defaultExpanded={index === defaultExpanded}
          sx={{
            width: "100%",
            boxShadow: "none",
            border: "none",
            "&::before": {
              display: "none",
            },
            "&:not(:last-child)": {
              marginBottom: 2,
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls={`faq-${keyPrefix}-${index}-content`}
            id={`faq-${keyPrefix}-${index}-header`}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              padding: 0,
              "& .MuiAccordionSummary-content": {
                margin: 0,
              },
              "& .MuiAccordionSummary-expandIconWrapper": {
                color: "inherit",
              },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                mr: "auto",
                textAlign: "left",
                textWrap: "pretty",
                fontWeight: 600,
              }}
            >
              {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {typeof item.answer === "string" ? (
              <Typography
                variant="h5"
                sx={{
                  mr: "auto",
                  textAlign: "left",
                  mt: 1,
                  textWrap: "pretty",
                  fontWeight: 400,
                }}
              >
                {item.answer}
              </Typography>
            ) : (
              item.answer
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default FAQAccordion;
